import './Home.css';
import massistLogo from './assets/massist-logo.png';

function IconPhone(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 5c0-.55.45-1 1-1h3l2 5-2 1.5a11 11 0 0 0 5 5L14.5 14l5 2v3c0 .55-.45 1-1 1C10.4 20 4 13.6 4 5Z" />
    </svg>
  );
}

function IconChat(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 5h16v10H9l-4 3.5V15H4V5Z" />
      <path d="M9 9.5c.3-1 1.1-1.5 2-1.5s1.7.5 1.7 1.4c0 1.2-1.7 1.3-1.7 2.6" />
      <circle cx="11" cy="14.2" r="0.15" fill="currentColor" />
    </svg>
  );
}

function IconMic(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <path d="M12 18v3" />
      <path d="M9 21h6" />
    </svg>
  );
}

function IconChart(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 20V10" />
      <path d="M10 20V4" />
      <path d="M16 20v-7" />
      <path d="M4 20h16" />
    </svg>
  );
}

function IconCheckShield(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 3.5 19 6v5.2c0 4.4-2.9 7.6-7 8.8-4.1-1.2-7-4.4-7-8.8V6l7-2.5Z" />
      <path d="m9 12 2 2 4-4.2" />
    </svg>
  );
}

function IconCart(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 4h2l1.6 11.2A2 2 0 0 0 8.6 17h8.8a2 2 0 0 0 2-1.7L20.5 8H6" />
      <circle cx="9" cy="20.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="17" cy="20.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconCoach(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 10.5 12 6l8 4.5-8 4.5-8-4.5Z" />
      <path d="M20 10.5V16" />
      <path d="M6 12.5v4.5c0 1.5 2.7 2.5 6 2.5s6-1 6-2.5v-4.5" />
    </svg>
  );
}

function IconShelf(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 4h18" />
      <path d="M3 20h18" />
      <path d="M4 4v6h6V4" />
      <path d="M4 14v6h4v-6" />
      <path d="M13 14v6h7v-6" />
    </svg>
  );
}

const USE_CASES = [
  {
    id: 'live-call-support',
    tab: 'Live Call Support',
    Icon: IconPhone,
    accent: 'blue',
    title: 'Live Call Support',
    tagline: 'Real-time co-pilot for every sales call',
    description:
      'Transcribes rep and retailer live with speaker diarization, tracks call KPIs as they happen, and surfaces context-aware suggestions — schemes, dues, focus SKUs, upsells — before the call ends.',
    href: '/live-call-support/',
  },
  {
    id: 'objection-handling',
    tab: 'Objection Handling',
    Icon: IconChat,
    accent: 'violet',
    title: 'Objection Handling',
    tagline: 'AI roleplay that trains reps to handle real pushback',
    description:
      'Sales officers practice against an AI shadow buyer — live Q&A, role-play as sales officer or merchant, and manager-style shadow reviews with analytics on every session.',
    href: '/objection-handling',
  },
  {
    id: 'stt',
    tab: 'Voice Ordering',
    Icon: IconMic,
    accent: 'orange',
    title: 'Voice Order Taking',
    tagline: 'Hands-free orders, spoken not typed',
    description:
      'Multilingual speech-to-text plus LLM-powered extraction lets reps build an order by voice, matched instantly against the live catalog — no screen, no typing.',
    href: '/stt/',
  },
  {
    id: 'brandpulse-audit',
    tab: 'BrandPulse Audit',
    Icon: IconChart,
    accent: 'red',
    title: 'BrandPulse Audit',
    tagline: 'Field merchandising, scored automatically',
    description:
      'Reps photograph a dealer visit; parallel vision agents score stock, bag quality, in-shop branding, and storefront presence against brand standards — with competitor analysis included.',
    href: '/brandpulse-audit/',
  },
  {
    id: 'readiness',
    tab: 'Grooming Check',
    Icon: IconCheckShield,
    accent: 'green',
    title: 'Field Readiness Check',
    tagline: 'A photo confirms every rep is visit-ready',
    description:
      'A quick photo is graded against a universal grooming and uniform checklist, plus any company-specific requirements — so every dealer visit starts on-brand.',
    href: '/readiness/',
  },
  {
    id: 'order-taking',
    tab: 'Order Taking',
    Icon: IconCart,
    accent: 'navy',
    title: 'Order Taking',
    tagline: 'Orders placed by voice, end to end',
    description:
      'A live AI voice-call ordering agent built for  customers order over a web or telephony call in Hindi, English, Tamil, or Arabic, with a real-time chat transcript alongside the conversation.',
    href: '/order-taking',
  },


  
  {
    id: 'sales-coach',
    tab: 'Sales Coach',
    Icon: IconCoach,
    accent: 'teal',
    title: 'Sales Coach',
    tagline: 'Your virtual NSM for daily performance reviews',
    description:
      'A voice AI coach that stands in for the sales head — daily and monthly call reviews, skill-training roleplay, and precomputed KPI context so every rep knows exactly what to fix tomorrow.',
    href: '/sales-coach',
  },
  {
    id: 'share-of-shelf',
    tab: 'Share of Shelf',
    Icon: IconShelf,
    accent: 'gold',
    title: 'Share of Shelf',
    tagline: 'Shelf presence and planogram compliance, scored from a photo',
    description:
      'Computer vision reads a single shelf photo to score share of shelf, SKU presence, and planogram compliance against competitors — store by store, with no manual audit.',
    href: 'https://shopshelf.massistcrm.com/',
  },
];

const ORBIT_STEP = 360 / USE_CASES.length;

function Home() {
  return (
    <div className="home">
      <header className="home-nav">
        <div className="home-nav-inner">
          <div className="home-brand">
            <img src={massistLogo} alt="Massist" className="home-nav-logo" />
            <span className="home-brand-divider" aria-hidden="true" />
            <span className="home-brand-product">Suite</span>
          </div>
          <nav className="home-tabs">
            {USE_CASES.map((uc) => (
              <a key={uc.id} href={uc.href} className="home-tab">
                {uc.tab}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main>
        <section className="home-hero">
          <div className="home-hero-bg" aria-hidden="true">
            <div className="hero-grid" />
            <div className="hero-blob hero-blob-a" />
            <div className="hero-blob hero-blob-b" />
            <div className="hero-blob hero-blob-c" />
          </div>

          <div className="home-hero-inner">
            <div className="orbit-stage">
              <div className="orbit-track" aria-hidden="true" />
              <div className="orbit-core">
                <span className="orbit-core-ping" aria-hidden="true" />
                <span className="orbit-core-ping orbit-core-ping-delay" aria-hidden="true" />
                <img src={massistLogo} alt="Massist" />
              </div>
              <div className="orbit-ring">
                {USE_CASES.map((uc, i) => (
                  <div
                    key={uc.id}
                    className="orbit-spoke"
                    style={{ '--angle': `${i * ORBIT_STEP}deg` }}
                    aria-hidden="true"
                  >
                    <span className="orbit-spoke-dot" style={{ animationDelay: `${i * 0.5}s` }} />
                  </div>
                ))}
                {USE_CASES.map((uc, i) => (
                  <div
                    key={uc.id}
                    className="orbit-item"
                    style={{ '--angle': `${i * ORBIT_STEP}deg` }}
                  >
                    <div className="orbit-item-fix">
                      <div className="orbit-item-spin">
                        <a href={uc.href} className={`orbit-badge accent-${uc.accent}`} title={uc.title}>
                          <uc.Icon className="orbit-badge-icon" />
                          <span className="orbit-badge-label">{uc.tab}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="hero-toast" aria-hidden="true">
              <span className="hero-toast-dot" />
              <div>
                <div className="hero-toast-title">Suggestion</div>
                <div className="hero-toast-body">Mention the Diwali scheme — 2 KPIs pending</div>
              </div>
            </div>
            <p className="home-kicker">The Massist Suite</p>
            <h1>One AI suite for every field-sales moment</h1>
            <p className="home-hero-copy">
              Purpose-built AI agents that support field reps end to end — before the
              visit, during the call, and after the order is placed. Jump straight into
              any of them below.
            </p>
          </div>
        </section>

        <section className="home-grid-section">
          <div className="home-grid-inner">
            <h2 className="home-section-title">Explore the suite</h2>
            <div className="home-grid">
              {USE_CASES.map((uc) => (
                <article key={uc.id} className={`home-card accent-${uc.accent}`}>
                  <div className="home-card-icon" aria-hidden="true">
                    <uc.Icon />
                  </div>
                  <div className="home-card-body">
                    <h3>{uc.title}</h3>
                    <p className="home-card-tagline">{uc.tagline}</p>
                    <p className="home-card-description">{uc.description}</p>
                  </div>
                  <a href={uc.href} className="home-card-cta">
                    Open {uc.tab}
                    <span aria-hidden="true">&rarr;</span>
                  </a>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="home-footer">
        <img src={massistLogo} alt="Massist" className="home-footer-logo" />
        <nav className="home-footer-links">
          {USE_CASES.map((uc) => (
            <a key={uc.id} href={uc.href}>
              {uc.tab}
            </a>
          ))}
        </nav>
        <span className="home-footer-copyright">&copy; {new Date().getFullYear()} Massist</span>
      </footer>
    </div>
  );
}

export default Home;
